var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.volunteerRegistration)?_c('VolunteerGridRegistration',{attrs:{"id":_vm.id,"registrations":_vm.volunteerRegistrations}}):_c('VolunteerGrid',{attrs:{"id":_vm.id,"submissions":_vm.submissions,"submissionsGroupedByVolunteer":_vm.submissionsGroupedByVolunteer,"registrations":_vm.volunteerRegistrations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }